import { fkId } from "./fkId";

/** Sigorta dosyası satırından FK id (yardımcı). */
export function resolveSigortaDosyaId(row) {
    if (!row) return null;
    return (
        fkId(row.sigorta_dosyasi) ??
        fkId(row.sigorta_dosya) ??
        fkId(row.sigorta_dosyasi_id) ??
        null
    );
}

/** Inline evrak bölümü yalnızca sigorta dosyası formunda. */
export const EVRAK_PARENTS = {
    "sigorta-dosyalari": {
        relationField: "sigorta_dosyasi",
        resolveParentId: (row) => (row?.id != null ? row.id : null),
    },
};
